import { BlogCategory, Subvertical, Vertical } from './Verticals';

export type Category = {
    id: string;
    title: string;
    metaTitle: string;
    subtitle: string;
    description: string;
    metaDescription: string;
} & (
    | {
          type: 'vertical';
          vertical: Vertical;
          subVertical?: never;
      }
    | {
          type: 'subvertical';
          vertical: Vertical;
          subVertical: Subvertical;
      }
    | {
          type: 'blogCategory';
          category: BlogCategory;
      }
);

export const BLOG_CATEGORIES: Category[] = [
    {
        id: 'weight-loss',
        title: 'Weight Loss',
        metaTitle: 'Weight Loss Tips & Strategies | Mosh',
        subtitle: 'Weight Loss: Expert Tips, Diets, and Sustainable Strategies',
        description:
            "Welcome to Mosh's Mental Health blog, your go-to resource for expert advice, tips, and information on mental health. Whether you're looking to manage stress, cope with anxiety, understand depression, or explore other mental health topics, our comprehensive articles are here to support you. Discover practical strategies, personal stories, and professional insights to help you navigate your mental health journey. Stay informed, stay healthy, and take control of your mental well-being with Mosh.",
        metaDescription:
            'Discover effective weight loss tips, diets, and strategies. Learn how to lose weight sustainably with expert advice from Mosh. Visit our Weight Loss blog now.',
        type: 'vertical',
        vertical: Vertical.WEIGHT_LOSS,
    },
    {
        id: 'hair-loss',
        title: 'Hair Loss',
        metaTitle: 'Hair Loss Solutions & Tips | Mosh',
        subtitle: 'Hair Loss: Expert Solutions, Treatments, and Tips',
        description:
            "Welcome to Mosh's Hair Loss blog category, your comprehensive resource for expert solutions, treatments, and tips to manage and prevent hair loss. Whether you're dealing with thinning hair, receding hairlines, or overall hair loss, our detailed articles provide valuable insights and practical advice. Discover effective treatments, from medications like Minoxidil to natural remedies and lifestyle changes. Learn how to maintain healthy hair and scalp, understand the causes of hair loss, and explore personalised treatment options. Empower yourself with the knowledge and tools you need to tackle hair loss confidently with Mosh.",
        metaDescription:
            'Explore effective hair loss solutions, treatments, and tips. Learn how to manage and prevent hair loss with expert advice from Mosh. Visit our Hair Loss blog now.',
        type: 'vertical',
        vertical: Vertical.HAIR,
    },
    {
        id: 'erectile-dysfunction',
        title: 'Erectile Dysfunction',
        metaTitle: 'Erectile Dysfunction: Causes, Treatments & Tips | Mosh',
        subtitle:
            'Erectile Dysfunction: Expert Insights, Treatment Options, and Support',
        description:
            "Welcome to Mosh's Erectile Dysfunction blog category, your comprehensive resource for understanding, managing, and treating ED. Our expert-written articles cover a wide range of topics, from the latest medical treatments and lifestyle interventions to psychological factors and relationship advice. Whether you're seeking information on medications like Sildenafil or Tadalafil, exploring natural remedies, or looking for ways to improve your overall sexual health, our in-depth content provides the knowledge and support you need. Discover practical tips, debunk common myths, and learn about the connection between ED and other health conditions. Take control of your sexual well-being and find the solutions that work best for you with Mosh's trusted guidance.",
        metaDescription:
            "Explore expert advice on erectile dysfunction causes, treatments, and management. Learn about ED solutions and lifestyle changes. Visit Mosh's ED blog now.",
        type: 'subvertical',
        vertical: Vertical.SEX,
        subVertical: Subvertical.ED,
    },
    {
        id: 'prostate-health',
        title: 'Prostate Health',
        metaTitle: 'Prostate Health: Tips, Treatments & Insights | Mosh',
        subtitle:
            'Prostate Health: Expert Tips, Treatments, and Lifestyle Advice',
        description:
            "Welcome to Mosh's Prostate Health blog category, your comprehensive resource for expert tips, treatments, and lifestyle advice to maintain a healthy prostate. Our detailed prostate health articles cover a wide range of topics, from understanding prostate cancer and its treatments to practical tips for prevention and maintaining overall prostate health. Whether you're looking for information on diet, exercise, or medical treatments, our content provides valuable insights and support. Discover the latest research, debunk common myths, and learn how to take proactive steps to ensure your prostate health. Empower yourself with the knowledge and tools you need to live a healthier life with Mosh.",
        metaDescription:
            'Explore expert advice on prostate health, including prevention tips, treatments, and lifestyle changes. Learn how to maintain a healthy prostate with Mosh.',
        type: 'vertical',
        vertical: Vertical.PROSTATE,
    },
    //    {
    //        id: 'mens-skincare',
    //        title: "Men's Skincare",
    //        metaTitle: "Men's Skincare Tips & Routines | Mosh",
    //        subtitle:
    //            "Men's Skincare: Expert Tips, Routines, and Product Recommendations",
    //        description:
    //            "Welcome to Mosh's Men's Skincare blog category, your ultimate resource for expert tips, routines, and product recommendations tailored specifically for men's skin. Whether you're dealing with oily skin, dryness, acne, or signs of aging, our comprehensive mens skincare articles provide valuable insights and practical advice to help you achieve healthy, glowing skin. Explore topics such as daily skincare routines, the best products for different skin types, and solutions for common skin concerns like razor burn and ingrown hairs. Empower yourself with the knowledge and tools you need to elevate your skincare game and maintain a fresh, youthful appearance. Start your journey to better skin with Mosh today.",
    //        metaDescription:
    //            "Discover effective men's skincare tips, routines, and product recommendations. Learn how to care for your skin with expert advice from Mosh.",
    //        type: 'vertical',
    //        vertical: Vertical.SKIN,
    //    },
    {
        id: 'premature-ejaculation',
        title: 'Premature Ejaculation',
        metaTitle:
            'Premature Ejaculation: Causes, Treatments & Solutions | Mosh',
        subtitle:
            'Premature Ejaculation: Expert Insights, Treatment Options, and Support',
        description:
            "Welcome to Mosh's Premature Ejaculation blog category, your comprehensive resource for understanding, managing, and treating PE. Our expert-written articles cover a wide range of topics, from behavioural techniques and psychological approaches to medical treatments and lifestyle modifications. Whether you're seeking information on PE medications, exploring natural remedies, or looking for ways to improve your sexual health and relationships, our in-depth content provides the knowledge and support you need. Discover practical tips, debunk common myths, and learn about the latest research in PE management. Take control of your sexual well-being and find the solutions that work best for you with Mosh's trusted guidance and personalised approach to premature ejaculation.",
        metaDescription:
            "Explore expert advice on premature ejaculation causes, treatments, & management. Learn about medications, techniques, & lifestyle changes. Visit Mosh's PE blog now.",
        type: 'subvertical',
        vertical: Vertical.SEX,
        subVertical: Subvertical.PE,
    },
    {
        id: 'mental-health',
        title: 'Mental Health',
        metaTitle: 'Mental Health Resources & Tips | Mosh',
        subtitle: 'Mental Health: Expert Advice, Tips, and Resources',
        description:
            "Welcome to Mosh's Mental Health blog, your go-to resource for expert advice, tips, and information on mental health. Whether you're looking to manage stress, cope with anxiety, understand depression, or explore other mental health topics, our comprehensive articles are here to support you. Discover practical strategies, personal stories, and professional insights to help you navigate your mental health journey. Stay informed, stay healthy, and take control of your mental well-being with Mosh.",
        metaDescription:
            "Explore expert advice, tips, and resources on mental health. Learn about managing stress, anxiety, depression, and more. Visit Mosh's Mental Health blog now.",
        type: 'vertical',
        vertical: Vertical.MENTAL_HEALTH,
    },
    {
        id: 'general-health',
        title: 'General Health',
        metaTitle: 'General Health Resources & Tips | Mosh',
        subtitle: 'General Health: Expert Advice, Tips, and Resources',
        description:
            "Welcome to Mosh's General Health blog, your go-to resource for expert advice, tips, and information on a wide range of health topics. Whether you're looking to improve your fitness, boost your immunity, or learn about common health conditions, our comprehensive articles are here to support you. Discover practical strategies, personal stories, and professional insights to help you take control of your health and well-being. Stay informed, stay healthy, and explore the latest research and trends in health and wellness with Mosh.",
        metaDescription:
            'Explore expert advice, tips, and resources on general health. Learn about fitness, immunity, and common health conditions. Visit Mosh’s General Health blog now.',
        type: 'blogCategory',
        category: BlogCategory.GENERAL_HEALTH,
    },
    {
        id: 'diabetes',
        title: 'Diabetes',
        metaTitle: 'Type 2 Diabetes Management & Prevention Tips | Mosh',
        subtitle:
            '(Type 2) Diabetes: Expert Advice, Management Tips, and Prevention Strategies',
        description:
            "Welcome to Mosh's Diabetes blog, your trusted resource for expert advice, management tips, and prevention strategies for type 2 diabetes. Whether you're looking to prevent diabetes, manage your condition, or understand your risk factors, our comprehensive diabetes articles provide valuable insights and practical guidance.\nExplore topics such as blood sugar management, healthy eating habits, exercise recommendations, and personalised diabetes care plans. Empower yourself with evidence-based knowledge and tools you need to effectively manage or prevent type 2 diabetes. Start your journey to better health with Mosh today.",
        metaDescription:
            'Discover expert diabetes management tips, prevention strategies, and lifestyle advice. Learn how to effectively manage type 2 diabetes with guidance from Mosh experts.',
        type: 'vertical',
        vertical: Vertical.DIABETES,
    },
];
